/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%] > mat-card[_ngcontent-%COMP%]{width:100%;padding:0}[_nghost-%COMP%] > mat-card[_ngcontent-%COMP%] > mat-card-footer[_ngcontent-%COMP%] > mat-toolbar[_ngcontent-%COMP%]{background-color:transparent;overflow:hidden}img.package-img[_ngcontent-%COMP%]{height:150px}"];
export { styles as styles };
